// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface LockIconSignature {
  Element: SVGSVGElement;
}

export const LockIcon: TOC<LockIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17 7V11C18.104 11 19 11.896 19 13V20C19 21.103 18.104 22 17 22H7C5.896 22 5 21.103 5 20V13C5 11.896 5.896 11 7 11V7C7 4.243 9.243 2 12 2C14.757 2 17 4.243 17 7ZM12 4C10.346 4 9 5.346 9 7V11H15V7C15 5.346 13.654 4 12 4ZM7 20V13H17L17.002 20H7ZM13.0607 17.5606C13.6465 16.9748 13.6465 16.0251 13.0607 15.4393C12.4749 14.8535 11.5252 14.8535 10.9394 15.4393C10.3536 16.0251 10.3536 16.9748 10.9394 17.5606C11.5252 18.1464 12.4749 18.1464 13.0607 17.5606Z"/>
</svg>
</template>;